import { render, staticRenderFns } from "./categoryTabs.vue?vue&type=template&id=6926a304&scoped=true&"
import script from "./categoryTabs.vue?vue&type=script&lang=js&"
export * from "./categoryTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6926a304",
  null
  
)

export default component.exports